import axios from '@/libs/api.request'
import {genURLParams} from '@/libs/urlparamhelper';

export const getPage = (params, urlParams) => {
  return axios.request({
    url: '/om/renewalorder/' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getAll = (params, urlParams) => {
  return axios.request({
    url: '/om/renewalorder/all' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getDetail = (params, urlParams) => {
  return axios.request({
    url: '/om/renewalorder/' + params.id + '' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getClientPage = (params, urlParams) => {
  return axios.request({
    url: '/om/renewalorder/getclientpage' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getMyUserGroupAll = (params, urlParams) => {
  return axios.request({
    url: '/om/renewalorder/getmyusergroupall' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getMyUserGroupPage = (params, urlParams) => {
  return axios.request({
    url: '/om/renewalorder/getmyusergrouppage' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const changeBusinessUser = (params, urlParams) => {
  return axios.request({
    url: '/om/renewalorder/changebusinessuser/' + params.id + '/' + params.userId + '' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const getMyBusinessPage = (params, urlParams) => {
  return axios.request({
    url: '/om/renewalorder/getmybusinesspage' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const confirmRecept = (params, urlParams) => {
  return axios.request({
    url: '/om/renewalorder/confirmrecept' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const cancel = (params, urlParams) => {
  return axios.request({
    url: '/om/renewalorder/cancel' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const getTeamReport = (params, urlParams) => {
  return axios.request({
    url: '/om/renewalorder/getteamreport' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getReport = (params, urlParams) => {
  return axios.request({
    url: '/om/renewalorder/getreport' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const closePayOrder = (params, urlParams) => {
  return axios.request({
    url: '/om/renewalorder/closepayorder/' + params.id + '' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const callbackClient = (params, urlParams) => {
  return axios.request({
    url: '/om/renewalorder/callbackclient' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const addToRemark = (params, urlParams) => {
  return axios.request({
    url: '/om/renewalorder/addtoremark/' + params.id + '' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const changeSim = (params, urlParams) => {
  return axios.request({
    url: '/om/renewalorder/changsim/' + params.id + '/' + params.changesim + '' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const refuseService = (params, urlParams) => {
  return axios.request({
    url: '/om/renewalorder/refuseservice' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const confirmServiceDatetime = (params, urlParams) => {
  return axios.request({
    url: '/om/renewalorder/confirmservicedatetime' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const confirmFileReady = (params, urlParams) => {
  return axios.request({
    url: '/om/renewalorder/confirmfileready' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const renewalPayPackage = (params, urlParams) => {
  return axios.request({
    url: '/om/renewalorder/renewalpaypackage' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const confirmRefuseService = (params, urlParams) => {
  return axios.request({
    url: '/om/renewalorder/confirmrefuseservice' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

